// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/lib/components/accordion/accordion.component.scss
// module id = 128
// module chunks = 0